import { Route } from '@angular/router';
import { Permissions } from '@dc-core/dc-backend/dc-enums';
import { developmentGuard } from 'src/app/modules/development/guards/development.guard';

import { permissionToGuard } from '../authentication/guards/permission-to.guard';

export const rankingRoutes: Route[] = [
    {
        path: 'ranked/dev',
        data: {
            permission: 'use ranked dev tools' as Permissions,
        },
        canActivate: [developmentGuard, permissionToGuard],
        loadComponent: () => import('./pages/ranked-dev/ranked-dev.component').then((c) => c.RankedDevComponent),
    },
    {
        path: 'ranked',
        loadComponent: () => import('./pages/ranked/ranked.component').then((c) => c.RankedComponent),
    },
    {
        path: 'ranked/leaderboard',
        loadComponent: () =>
            import('./pages/ranked-leaderboard/ranked-leaderboard.component').then((c) => c.RankedLeaderboardComponent),
    },
];
